import Link from 'next/link';
import Image from 'next/image';
import Icon from '@/components/ui/AppIcon';

export default function Footer() {
  return (
    <footer className="py-12 px-6 md:px-12 border-t border-border">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Logo */}
          <Link href="/homepage" className="flex items-center gap-2 group">
            <Image
              src="/assets/images/ChatGPT_Image_13._feb._2026_10.17.16-1771010403596.png"
              alt="Dataflowsuite Logo"
              width={32}
              height={32}
              className="object-contain"
            />
            <span className="text-xl font-serif text-foreground">Dataflowsuite</span>
          </Link>

          {/* Navigation Links */}
          <nav className="flex items-center gap-8 text-sm">
            <Link href="/homepage" className="text-muted-foreground hover:text-foreground transition-colors">
              Hjem
            </Link>
            <Link href="/portal/login" className="text-muted-foreground hover:text-foreground transition-colors">
              Portal
            </Link>
            <Link href="/portal/api-docs" className="text-muted-foreground hover:text-foreground transition-colors">
              API Docs
            </Link>
            <Link href="#pricing" className="text-muted-foreground hover:text-foreground transition-colors">
              Priser
            </Link>
            <Link href="#contact" className="text-muted-foreground hover:text-foreground transition-colors">
              Kontakt
            </Link>
          </nav>

          {/* Copyright */}
          <div className="flex items-center gap-6">
            <a
              href="mailto:kontakt@dataflowsuite.dk"
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              <Icon name="EnvelopeIcon" size={20} />
            </a>
            <span className="text-xs text-muted-foreground uppercase tracking-wider">
              © 2026 Dataflowsuite
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}